import * as React from 'react';

import { useFiltersContext } from '@/packages/Filters';

import { getLink } from '../utils/getLink';

export function useLink(): string {
  const { jsonQuery } = useFiltersContext();
  const [link, setLink] = React.useState('#');

  React.useEffect(() => {
    setLink(getLink(jsonQuery));
  }, [jsonQuery]);

  return link;
}
